import { createApp } from '@app/adapters/create-app'
import AsyncRenderError from '@app/templates/components/async-render-error.vue'

export default (): void => {
  const unsubscribers: Array<() => void> = []

  window.onDomLoad(function ($dom) {
    const doc = $dom[0]

    const renderErrorHandler = (): void => {
      const element = doc.querySelector(
        "[data-behaviour='async-render-error']"
      ) as HTMLElement

      if (element) {
        createApp(AsyncRenderError, element.dataset).mount(element)
      }
    }

    unsubscribers.forEach((unsubscribe) => {
      unsubscribe()
    })

    window.eventHub.$on('sf-live-inputs:asyncRenderTimeout', renderErrorHandler)

    unsubscribers.push(() => {
      window.eventHub.$off(
        'sf-live-inputs:asyncRenderTimeout',
        renderErrorHandler
      )
    })
  })
}
